// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAPu1LTKCPWRixBDkhTzy942qwoKrvKk2E",
    authDomain: "mnd-noumo.firebaseapp.com",
    projectId: "mnd-noumo",
    storageBucket: "mnd-noumo.appspot.com",
    messagingSenderId: "636900980642",
    appId: "1:636900980642:web:4872e16ba7d6eee19464fb"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
